import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { Primitive, type PrimitiveProps } from 'reka-ui';
    import { type AlertVariants, alertVariants } from '.';
    import { CircleAlert, CheckCircle, XCircle, Info } from 'lucide-vue-next';
    import { computed } from 'vue';

    interface Props extends PrimitiveProps {
        variant?: AlertVariants['variant'];
        class?: HTMLAttributes['class'];
        loading?: boolean;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Alert',
  props: {
    variant: {},
    class: {},
    loading: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: 'div' }
  },
  setup(__props: any) {

    const props = __props;

    const icon = computed(() => {
        switch (props.variant) {
            case 'success':
                return CheckCircle;
            case 'error':
                return XCircle;
            case 'info':
                return Info;
            case 'warning':
            default:
                return CircleAlert;
        }
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Primitive), {
    "data-slot": "alert",
    as: _ctx.as,
    "as-child": _ctx.asChild,
    class: _normalizeClass(_unref(cn)(_unref(alertVariants)({ variant: _ctx.variant }), props.class))
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(icon.value), { class: "size-6 shrink-0" })),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["as", "as-child", "class"]))
}
}

})